import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'lfwms-lf-gaugemeter',
  templateUrl: './lf-gauge-meter.component.html',
  styleUrls: ['./lf-gauge-meter.component.css']
})
export class LfGaugeMeterComponent implements OnInit, OnChanges {

  constructor() {
  }


   // @Input()
   public bigPercent; // = 54.68;
   @Input()
   public total; // = '12,800';
   @Input()
   public colors = ['#00C72E', '#2294E3', '#FF0000', '#1656df', '#00c72e', '#f65555', '#FFA500', '#6744c3', '#229977', 'FF4500'];
   @Input()
   public values = []; // = [25, 30, 10, 15, 5, 9];
   @Input()
   public valueNames = []; // = [25, 30, 10, 15, 5, 9];
   public valueTextsRounded = []; // Used for only first
   public arcDetails; //  = this.getArcDetails(this.values);



   public tooltipEnabled = false;
   public toolTipStyle = { top: '0', left: '0', color: 'rgb(255, 71, 71)' };
   public tootipText = '';


   ngOnInit() {
      this.updateGraphVars();
   }

   public ngOnChanges(changes: SimpleChanges) {
      // refresh the graph on any change
      this.updateGraphVars();
    }

  private updateGraphVars() {
    if (this.values) {
      this.bigPercent = this.values.length === 1 ? this.values[0] + '%' : ' 0';
      this.arcDetails = this.getArcDetails(this.values);

      this.valueTextsRounded[0] = Math.round(this.total * 0.01 * this.values[0]);
      this.valueTextsRounded[1] = Math.round(this.total * 0.01 * this.values[1]);
      this.valueTextsRounded[2] = Math.round(this.total * 0.01 * this.values[2]);

     }else {
       this.bigPercent = 0;
       this.total = 0;
       this.values = [];
       this.arcDetails = this.getArcDetails(this.values);
     }
  }

  public getArcDetails(values: number[]) {
     let offset = 75;
     const arcDetails = [];
     const maxPercent = 0.60;

     for (let i = 0; i < values.length; i++) {
       values[i]  = values[i] ? values[i] : 0 ; // handle NaN and NULL
       const arcDetail = {};
       arcDetail['relativePercent'] = maxPercent * values[i] ;
       /*The rounding problem can be avoided by using numbers represented in exponential notation:
          Number(Math.round(1.005+'e2')+'e-2'); */
       const percentToRound = Number(values[i] + 'e2');
       arcDetail['percent'] = Number(Math.round(percentToRound) + 'e-2')
       arcDetail['color'] = this.colors[i];
       arcDetail['offset'] = offset;
       // arcDetail['calculatedValue'] = this.total * 0.01 * values[i];
       arcDetail['index'] = i;
       offset = offset - arcDetail['relativePercent'];
       arcDetails.push(arcDetail);
     }
     return arcDetails;

   }


   showTooltip(event, arc) {
   //  + '-- '+ event.screenY +' '+ event.clientY +' '+ event.pageY +'-- '+ event.screenX +' '+ event.clientX +' '+ event.pageX;

   if (this.valueNames && this.valueNames.length ===  this.values.length) {
      this.tootipText = this.valueNames[arc.index];
       this.tootipText =  this.tootipText + ' ' + arc.percent + '%';
    }else {
     this.tootipText = arc.percent + '%';
    }

     this.toolTipStyle.left = (event.layerX) + 'px';
     this.toolTipStyle.top = (event.layerY) + 'px';
     this.toolTipStyle.color = arc.color;
     // console.log(event, this.toolTipStyle);
     this.tooltipEnabled = true;
   }
   hideToolTip() {
     // console.log('hide');
     this.tooltipEnabled = false;
   }
   toJSONString(obj) {
     return JSON.stringify(obj);
   }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/platform/lf-gauge-meter/lf-gauge-meter.component.ts